import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import {
  CmsConfig,
  DeferLoadingStrategy,
  FeaturesConfigModule,
  I18nModule,
  provideConfig,
  UrlModule,
} from '@spartacus/core';
import { PromotionsModule } from '@spartacus/storefront';
import { CartCouponModule } from '../cart-coupon/cart-coupon.module';
import { CartSharedModule } from '../cart-shared/cart-shared.module';
import { CartDeleteModule } from './cart-delete/cart-delete.module';
import { ShimanoCartDetailsComponent } from './cart-details.component';
import { CartExportModule } from './cart-export/cart-export.module';
import { CartQuickOrderModule } from './cart-quick-order/cart-quick-order.module';

@NgModule({
  imports: [
    MatIconModule,
    CartSharedModule,
    CartExportModule,
    CartQuickOrderModule,
    CartDeleteModule,
    CommonModule,
    CartCouponModule,
    RouterModule,
    UrlModule,
    PromotionsModule,
    FeaturesConfigModule,
    I18nModule,
    MatExpansionModule,
    ShimanoCartDetailsComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CartComponent: {
          component: ShimanoCartDetailsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  exports: [ShimanoCartDetailsComponent],
})
export class CartDetailsModule {}
